<div class="relative mt-8 flex flex-auto flex-col items-center gap-8">
  @if (email(); as email) {
    <div class="w-full max-w-3xl">
      <div
        class="surface-default flex flex-col sm:flex-row sm:items-center justify-between gap-4 rounded-xl border border-gray-5 p-5 shadow-xs"
      >
        <div class="flex flex-col gap-2">
          <div class="font-semibold text-base text-neutral-12">
            {{ email.action | emailActionDisplay }}
          </div>
          <div class="text-xs text-neutral-10">Catégorie : {{ email.tag | emailTagDisplay }}</div>
          <div class="flex items-center gap-2 text-xs">
            <span
              class="inline-flex items-center px-2.5 py-0.5 rounded-full font-semibold"
              [class.bg-green-3]="email.status === emailStatus.SENT"
              [class.text-green-11]="email.status === emailStatus.SENT"
              [class.bg-red-3]="email.status === emailStatus.CANCELED"
              [class.text-red-11]="email.status === emailStatus.CANCELED"
              [class.bg-amber-3]="
                email.status === emailStatus.PENDING || email.status === emailStatus.PROCESSING
              "
              [class.text-amber-11]="
                email.status === emailStatus.PENDING || email.status === emailStatus.PROCESSING
              "
            >
              {{ email.status | emailStatusDisplay }}
            </span>
            @if (email.status === emailStatus.SENT && email.sendDate) {
              <span class="text-neutral-11"> le {{ email.sendDate | luxonDate: 'dd/LL/yyyy, HH:mm' }} </span>
            }
          </div>
        </div>

        <div class="flex items-center gap-2 shrink-0">
          <button mat-flat-button class="primary text-xs!" [disabled]="isResending()" (click)="onResend()">
            <mat-icon class="mr-1 text-sm! w-4! h-4!" [class.animate-spin]="isResending()">
              {{ isResending() ? 'hourglass_empty' : 'send' }}
            </mat-icon>
            {{ isResending() ? 'Envoi en cours...' : "Renvoyer l'e-mail" }}
          </button>
        </div>
      </div>
    </div>
    <div class="w-full max-w-3xl">
      <core-email-viewer [email]="email" />
    </div>
  }
</div>
